import React, { Component } from "react";
import { Panel,
          Modal,
          Button,
          FormGroup,
          FormControl,
          ControlLabel,
          Grid,
          Row,
          Col,
          Image,
          Checkbox,
          DropdownButton,
          MenuItem,
          ButtonGroup,
          Glyphicon,
          Tooltip,
          OverlayTrigger,
          Radio} from "react-bootstrap";
import ReactLoading from 'react-loading';
import Datetime from 'react-datetime';
import "./style.css";
import _ from 'underscore';
import GoogleMapReact from 'google-map-react';
import Geocode from "react-geocode";

import moment from 'moment';

//Props:
//dropDownType - Some string we make up to identify the fields we need to display. Not necessarily existing in DB. Check renderFields()
//newDropDown - temp object being manipulated, and later submitted
//pressedDropDown
//dropDowns - all dropdowns, for looping to branches and stuff
class FormDataAddItemPanel extends Component {

  constructor(props, context) {
      super(props, context);


      this.state = {
        showMapOverlay: false,
        eventReoccurring: false
      };
      Geocode.setApiKey("AIzaSyDC_uFHUc5D6KXs5Ng1iVJsbJsQZvRpz6k");
      this.renderFields = this.renderFields.bind(this);
      this.renderMapOverlay = this.renderMapOverlay.bind(this);
  }

  componentWillReceiveProps(nextProps){
    const {dropDownType,newDropDown} = nextProps;

    if(dropDownType === 'Event'){
      const eventReoccurring = newDropDown.isReoccurring ? true : false

      this.setState({ eventReoccurring });
    }
  }

  render() {
    return (<div>
            {this.props.pressedDropDown
               ? this.renderFields()
               : null
            }
            {this.props.pressedDropDown
               ? <div className="active-filter" style={{marginBottom: 30}}>
                   <h5>Filter:</h5>
                     <ButtonGroup className="mt-3">
                         <Button variant="secondary" className={this.props.tableFilter.isActive == true ? 'active':''} onClick={()=>{this.props.filterByActive(true)}}>Active</Button>
                         <Button variant="secondary" className={this.props.tableFilter.isActive == false ? 'active':''} onClick={()=>{this.props.filterByActive(false)}}>Inactive</Button>
                     </ButtonGroup>
                 </div>
               : null
            }

            {this.renderMapOverlay()}
           </div>);
  }

  renderFields() {
    var dropDownType = this.props.dropDownType;
    var newDropDown = this.props.newDropDown;
    var pressedDropDown = this.props.pressedDropDown;
    var panelFields = [];

    const name = pressedDropDown ? pressedDropDown.name : 'No Dropwdown';
    const title = pressedDropDown ? pressedDropDown.title : '';

    const titleString = title || name;
    var renderDropDowns = (dropDownName) => {
                                  var items = [];
                                  var dropDownIndex = null;
                                  var branchDropDown = _.find(this.props.dropDowns, (dropDown)=>{
                                                                return dropDown.name == dropDownName;
                                                              });

                                  dropDownIndex = this.props.dropDowns.indexOf(branchDropDown);
                                  if(this.props.dropDowns != null && dropDownIndex != null && this.props.dropDowns[dropDownIndex].items.length > 0) {
                                    this.props.dropDowns[dropDownIndex].items.map((item, i)=>{
                                        //items.push(<Dropdown.Item eventKey={branch.name}>{branch.name}</Dropdown.Item>);
                                        items.push(<MenuItem key={i} style={{width: "100%"}} eventKey={item.id}>{item.name}</MenuItem>)
                                      });
                                  } else {
                                    items.push(<MenuItem  key={"No Items"} eventKey="1" disabled>No Items</MenuItem>);
                                  }
                                  return items;
                                  }

    switch(dropDownType) {
      case "Client":
        panelFields.push(<Row key={"itemNameLabel"} style={{marginTop: "3%"}}>
                            <Col md={5} inline="true" style={{paddingLeft: 0}}>
                              <div style={{textAlign: 'left'}}>
                                <Glyphicon glyph="plus" style={{marginRight: 15}}/>
                                {titleString + " Name"}
                              </div>
                            </Col>
                          </Row>);

        panelFields.push(<Row key={"itemNameInputField"} style={{marginBottom: 10}}>
                          <Col md={7} inline="true" style={{ padding: 0}}>
                              <input type="text" style={{width: "100%", marginTop: 10}} value={newDropDown.name ? newDropDown.name : ""} onChange={(e)=>{
                                this.props.onChangeNewItemField("name", e.target.value)
                              }}/>
                          </Col>
                          <Col md={3} inline="true">
                            <Button variant="success" className="green-btn" onClick={()=>{this.props.onAddItem()}}>Add {dropDownType}</Button>
                          </Col>
                        </Row>);
      break;
      case "Branch":
        /*Ena: Removed this CSA-638
          panelFields.push(<Row key={"branchClient"}>
                            <FormGroup  className={"md-5"}
                                                          style={{textAlign: "center", borderRadius: 5, marginTop: "3%", width: "40%"}}>
                                <FormControl  componentClass="select" placeholder="Client"
                                              style={{width: "100%"}}
                                              defaultValue={""}
                                              value={newDropDown.client ? this.props.getNameForRecno(newDropDown.client, "Client") : ""}
                                              onChange={(e)=>{
                                                console.log("e: ", e.target.value);
                                                  this.props.onChangeNewItemField("client", this.props.getRecnoForName(e.target.value, "Client"));
                                                }}>
                                              {this.renderDropDowns("Client")}
                                </FormControl>
                            </FormGroup>
                        </Row>);
        */

        panelFields.push(<Row key={"itemNameLabel"} style={{marginTop: "3%"}}>
                            <Col md={5} inline="true" style={{paddingLeft: 0}}>
                              <div style={{textAlign: 'left'}}>
                                <Glyphicon glyph="plus" style={{marginRight: 15}}/>
                                {titleString + " Name"}
                              </div>
                            </Col>
                          </Row>);

        panelFields.push(<Row key={"itemNameInputField"} style={{marginBottom: 10}}>
                          <Col md={7} inline="true" style={{ padding: 0}}>
                              <input type="text" style={{width: "100%", marginTop: 10}} value={newDropDown.name ? newDropDown.name : ""} onChange={(e)=>{
                                this.props.onChangeNewItemField("name", e.target.value)
                              }}/>
                          </Col>
                          <Col md={3} inline="true">
                            <Button variant="success" className="green-btn" onClick={()=>{this.props.onAddItem()}}>Add {dropDownType}</Button>
                          </Col>
                        </Row>);
      break;
      case "Facility":

        panelFields.push(<Row key={"facilityClients"}>
                            <FormGroup className="col-md-6" style={{textAlign: "center", borderRadius: 5, marginTop: "3%", flexDirection: "row"}}>
                                <ControlLabel className="login_label">Client</ControlLabel>
                                <FormControl  componentClass="select" placeholder="Client"
                                              style={{width: "100%"}}
                                              value={newDropDown.client ? newDropDown.client : ""}
                                              onChange={(e)=>{
                                                  var newFilter = this.props.tableFilter;
                                                  newFilter["client"] = e.target.value;
                                                  this.props.setTableFilter(newFilter);
                                                  this.props.onChangeNewItemField("client", e.target.value);
                                                }}>
                                              {this.renderDropDowns("Client")}
                                </FormControl>
                            </FormGroup>

                            <FormGroup className="col-md-6" style={{textAlign: "center", borderRadius: 5, marginTop: "3%", flexDirection: "row"}}>
                                <ControlLabel className="login_label">Branch</ControlLabel>
                                <FormControl  componentClass="select" placeholder="Branch"
                                              style={{width: "100%"}}
                                              value={newDropDown.branch ? newDropDown.branch : ""}
                                              onChange={(e)=>{
                                                  var newFilter = this.props.tableFilter;
                                                  newFilter["branch"] = e.target.value;
                                                  this.props.setTableFilter(newFilter);

                                                  this.props.onChangeNewItemField("branch", e.target.value);
                                                }}>
                                              {this.renderDropDowns("Branch")}
                                </FormControl>
                            </FormGroup>
                        </Row>);


          panelFields.push(<Row key={"itemNameLabel"}>
                              <Col md={5} inline="true" style={{paddingLeft: 0}}>
                                <div style={{textAlign: 'left'}}>
                                  <Glyphicon glyph="plus" style={{marginRight: 15}}/>
                                  {titleString + " Name"}
                                </div>
                              </Col>
                            </Row>);

          panelFields.push(<Row key={"itemNameInputField"} style={{marginBottom: 10}}>
                            <Col md={6} inline="true" style={{ padding: 0}}>
                              <input type="text" style={{width: "100%", marginTop: 10}} value={newDropDown.name ? newDropDown.name : ""} onChange={(e)=>{
                                this.props.onChangeNewItemField("name", e.target.value)
                              }}/>
                            </Col>

                            <Col md={1} inline="true" style={{ padding: 0}}>
                              <OverlayTrigger
                                  placement="top"
                                  delay={200}
                                  overlay={<Tooltip id="overlay-example">
                                                     {newDropDown.address ? "(Current: "+newDropDown.address + ")" : "Set a Map location"}

                                          </Tooltip>}>
                                    <Glyphicon glyph="map-marker"
                                                 onClick={()=>{this.setState({showMapOverlay: true})}}
                                                 style={{marginLeft: 15, cursor: "pointer", color: "black", fontSize: 26}}/>
                               </OverlayTrigger>
                            </Col>

                            <Col md={3} inline="true">
                              <Button variant="success" className="green-btn" onClick={()=>{this.props.onAddItem()}}>Add {dropDownType}</Button>
                            </Col>
                          </Row>);
      break;
      case "Facility Location":

        panelFields.push(<Row key={"facility"}>
                            <FormGroup className={"md-5"}
                                                          style={{textAlign: "center", borderRadius: 5, marginTop: "3%", width: "40%"}}>
                                <FormControl  componentClass="select" placeholder="Branch"
                                              style={{width: "100%"}}
                                              value={newDropDown.facility ? this.props.getNameForRecno(newDropDown.facility, "Facility") : ""}
                                              onChange={(e)=>{
                                                  this.props.onChangeNewItemField("facility", this.props.getRecnoForName(e.target.value, "Facility"));

                                                  var facility = this.getItemWithId(this.props.getRecnoForName(e.target.value, "Facility"), "Facility");
                                                  var newFilter = this.props.tableFilter;
                                                  newFilter["facility"] = e.target.value;
                                                  this.props.setTableFilter(newFilter);

                                                  if(facility != null) {
                                                    this.props.onChangeNewItemField("latitude", facility.latitude);
                                                    this.props.onChangeNewItemField("longitude", facility.longitude);
                                                  }

                                                }}>
                                              {this.renderDropDowns("Facility")}
                                </FormControl>
                            </FormGroup>

                        </Row>);

        panelFields.push(<Row key={"itemNameLabel"}>
                            <Col md={5} inline="true" style={{paddingLeft: 0}}>
                              <div style={{textAlign: 'left'}}>
                                <Glyphicon glyph="plus" style={{marginRight: 15}}/>
                                {titleString + " Name"}
                              </div>
                            </Col>
                          </Row>);

        panelFields.push(<Row key={"itemNameInputField"} style={{marginBottom: 10}}>
                          <Col md={6} inline="true" style={{ padding: 0}}>
                              <input type="text" style={{width: "100%", marginTop: 10}} value={newDropDown.name ? newDropDown.name : ""} onChange={(e)=>{
                                this.props.onChangeNewItemField("name", e.target.value)
                              }}/>
                          </Col>
                          <Col md={1} inline="true" style={{ padding: 0}}>
                            <OverlayTrigger
                                placement="top"
                                delay={200}
                                overlay={<Tooltip id="overlay-example">
                                                  Set a Map location
                                        </Tooltip>}>
                                  <Glyphicon glyph="map-marker"
                                               onClick={()=>{this.setState({showMapOverlay: true})}}
                                               style={{marginLeft: 15, cursor: "pointer", color: "black", fontSize: 26}}/>
                             </OverlayTrigger>
                          </Col>
                          <Col md={2} inline="true">
                            <Button variant="success" className="green-btn" onClick={()=>{this.props.onAddItem()}}>Add {dropDownType}</Button>
                          </Col>
                        </Row>);
      break;
      case "Event":
        panelFields.push(
          <React.Fragment key={'eventAddItem'}>
            <Row>
              <Col md={4} mdOffset={4}>
                <FormGroup
                  style={{textAlign: "center", borderRadius: 5, marginTop: "1%", width: "100%"}}
                >
                  <ControlLabel className="login_label">Facility</ControlLabel>
                  <FormControl  componentClass="select"
                    style={{width: "100%"}}
                    value={newDropDown.facility ? newDropDown.facility : ""}
                    onChange={(e)=>{
                        var newFilter = this.props.tableFilter;
                        newFilter["facility"] = e.target.value;
                        this.props.setTableFilter(newFilter);
                        this.props.onChangeNewItemField("facility", e.target.value);
                      }}
                    >
                      {this.renderDropDowns("Facility")}
                    </FormControl>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={4} mdOffset={4}>
                <FormGroup>
                  <div style={{textAlign: 'left'}}>
                    <Glyphicon glyph="plus" style={{marginRight: 15}}/>
                    {titleString + " Name"}
                  </div>
                  <div>
                    <FormControl 
                      type='text'
                      value={newDropDown.name || ''}
                      onChange={(e) => {
                        this.props.onChangeNewItemField("name", e.target.value)
                      }}
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={4} mdOffset={4}>
                <FormGroup>
                  <div style={{textAlign: 'left'}}>
                    <Glyphicon glyph="time" style={{marginRight: 15}}/>
                    Date & Time
                  </div>
                  <div>
                    <Datetime
                      inputProps={{readOnly: true}}
                      dateFormat={"MM-DD-YYYY"}
                      value={newDropDown.date ? new Date(newDropDown.date): null}
                      onChange={(e)=>{
                        this.props.onChangeNewItemField("date", e.format("YYYY-MM-DD hh:mm:ss a"));
                      }}/>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={3} mdOffset={4}>
                <FormGroup style={{textAlign:'left'}}>
                  <Checkbox 
                    checked={newDropDown.isReoccurring  ? true : false} 
                    onChange={this.onChangeEventReoccurring}>Reoccuring</Checkbox>
                </FormGroup>
              </Col>
            </Row>
            {this.renderEventReoccuring()}
            <Row>
              <Col md={4} mdOffset={4}>
                <div style={{paddingTop: 10, paddingBottom: 10, justifyContent: 'right'}}>
                  <Button variant="success" className="green-btn" onClick={()=>{this.props.onAddItem()}}>Add {dropDownType}</Button>
                </div>
              </Col>
            </Row>
          </React.Fragment>
        );
      break;
      case "Call Type":
        panelFields.push(<Row key={"itemNameLabel"} style={{marginTop: "3%"}}>
                            <Col md={5} inline="true" style={{paddingLeft: 0}}>
                              <div style={{textAlign: 'left'}}>
                                <Glyphicon glyph="plus" style={{marginRight: 15}}/>
                                {titleString + " Name"}
                              </div>
                            </Col>
                          </Row>);

        panelFields.push(<Row key={"itemNameInputField"} style={{marginBottom: 10}}>
                          <Col md={7} inline="true" style={{ padding: 0}}>
                              <input type="text" style={{width: "100%", marginTop: 10}} value={newDropDown.name ? newDropDown.name : ""} onChange={(e)=>{
                                this.props.onChangeNewItemField("name", e.target.value)
                              }}/>
                          </Col>
                          <Col md={3} inline="true">
                            <Button variant="success" className="green-btn" onClick={()=>{this.props.onAddItem()}}>Add {dropDownType}</Button>
                          </Col>
                        </Row>);
      break;
      case "Incident Type":
        panelFields.push(<Row key={"itemNameLabel"} style={{marginTop: "3%"}}>
                            <Col md={5} inline="true" style={{paddingLeft: 0}}>
                              <div style={{textAlign: 'left'}}>
                                <Glyphicon glyph="plus" style={{marginRight: 15}}/>
                                {titleString + " Name"}
                              </div>
                            </Col>
                          </Row>);

        panelFields.push(<Row key={"itemNameInputField"} style={{marginBottom: 10}}>
                          <Col md={7} inline="true" style={{ padding: 0}}>
                              <input type="text" style={{width: "100%", marginTop: 10}} value={newDropDown.name ? newDropDown.name : ""} onChange={(e)=>{
                                this.props.onChangeNewItemField("name", e.target.value)
                              }}/>
                          </Col>
                          <Col md={3} inline="true">
                            <Button variant="success" className="green-btn" onClick={()=>{this.props.onAddItem()}}>Add {dropDownType}</Button>
                          </Col>
                        </Row>);
      break;
      case "Skill":
        panelFields.push(<Row key={"itemNameLabel"} style={{marginTop: "3%"}}>
                            <Col md={5} inline="true" style={{paddingLeft: 0}}>
                              <div style={{textAlign: 'left'}}>
                                <Glyphicon glyph="plus" style={{marginRight: 15}}/>
                                {titleString + " Name"}
                              </div>
                            </Col>
                          </Row>);

        panelFields.push(<Row key={"itemNameInputField"} style={{marginBottom: 10}}>
                          <Col md={7} inline="true" style={{ padding: 0}}>
                              <input type="text" style={{width: "100%", marginTop: 10}} value={newDropDown.name ? newDropDown.name : ""} onChange={(e)=>{
                                this.props.onChangeNewItemField("name", e.target.value)
                              }}/>
                          </Col>
                          <Col md={2} inline="true">
                            <Button variant="success" className="green-btn" onClick={()=>{this.props.onAddItem()}}>Add {dropDownType}</Button>
                          </Col>
                        </Row>);
      break;
      case "Auto Email":
      break;
      default:

        //"Custom" fields
        panelFields.push(
          <Row key={'customName'}>
            <Col md={5} mdOffset={7}>
              <input type='text' className='form-control' onChange={this.onChangeCustomName} value={titleString} />
            </Col>
          </Row>
        );

        panelFields.push(<Row key={"itemNameLabel"} style={{marginTop: "3%"}}>
                            <Col md={5} inline="true" style={{paddingLeft: 0}}>
                              <div style={{textAlign: 'left'}}>
                                <Glyphicon glyph="plus" style={{marginRight: 15}}/>
                                {titleString + " Name"}
                              </div>
                            </Col>
                          </Row>);

        panelFields.push(<Row key={"itemNameInputField"} style={{marginBottom: 10}}>
                          <Col md={7} inline="true" style={{ padding: 0}}>
                              <input type="text" style={{width: "100%", marginTop: 10}} value={newDropDown.name ? newDropDown.name : ""} onChange={(e)=>{
                                this.props.onChangeNewItemField("name", e.target.value)
                              }}/>
                          </Col>
                          <Col md={5} inline="true">
                            <Button variant="success" className="green-btn" onClick={()=>{this.props.onAddItem()}}>Add {titleString}</Button>
                          </Col>
                        </Row>);
      break;
    }

    return (<Col lg={12}>
              <div style={{width: "100%", alignSelf: "center", justifyContent: "space-between"}}>
                {
                  panelFields
                }
              </div>
          </Col>);
  }

  onChangeCustomName = (e) =>{
    const {value} = e.target;
    const {pressedDropDown} = this.props;

    this.props.onChangeCustomName(value,pressedDropDown);
  }

  renderDropDowns(type) {

    var itemList = _.find(this.props.dropDowns, (dropDown)=>{
                                  return dropDown.name === type;
                                });

    var choices = [];
    if(itemList.items.length > 0) {
      choices.push(<option key={"placeholder"} value={""}>Select {type}</option>);
      itemList.items.map((item, index) => {
                                  if(item.isActive) {
                                    choices.push(<option key={index} value={item.name}>{item.name}</option>)
                                  }

                              });
    }

    return choices;
  }

  renderMapOverlay() {
    var newDropDown = this.props.newDropDown;
    var name = newDropDown && newDropDown.name ? newDropDown.name : "No Facility Name yet";

    var mapOptions = (maps) => {
      return {
                mapTypeControl: true,
                mapTypeId: maps.MapTypeId.SATELLITE,
              }
    }

    var longitude = newDropDown && newDropDown.longitude ? parseFloat(newDropDown.longitude) : 122.9563;
    var latitude = newDropDown && newDropDown.latitude ? parseFloat(newDropDown.latitude) : 10.6840;
    var center = {lat: latitude, lng: longitude};
    return (<Modal style={{marginTop: "10%"}}
                    show={this.state.showMapOverlay}
                    onExit={()=>{this.setState({showMapOverlay: false})}}>
            <Modal.Header>
              <b style={{fontSize: 20}}>{name}</b>
            </Modal.Header>
            <Modal.Body>

              <div style={{textAlign: 'center'}}>
                {this.props.dropDownType === "Facility"
                   ? <Row style={{alignItems: "left"}}>
                        <input type="text" style={{width: '90%', textAlign: "center", textAlign: "left", marginBottom: 20,marginRight: 20, marginLeft: 20, padding: 15}} value={this.props.newDropDown != null && this.props.newDropDown.address != null ? this.props.newDropDown.address : "No Address"} onChange={(e)=>{
                          this.props.onChangeNewItemField("address", e.target.value);
                          Geocode.fromAddress(e.target.value).then(
                                  response => {
                                    const { lat, lng } = response.results[0].geometry.location;
                                    this.props.onChangeNewItemField("latitude", lat);
                                    this.props.onChangeNewItemField("longitude", lng);
                                  },
                                  error => {
                                    console.error(error);
                                  }
                                );

                        }}/>
                      </Row>
                   : null
                }
                <div style={{ height: '40vh', width: '100%' }}>
                       <GoogleMapReact
                             options={mapOptions}
                             bootstrapURLKeys={{ key: "AIzaSyDC_uFHUc5D6KXs5Ng1iVJsbJsQZvRpz6k" }}
                             onClick={({ x, y, lat, lng, event })=>{
                               this.props.onChangeNewItemField("latitude", lat);
                               this.props.onChangeNewItemField("longitude", lng);

                             }}
                             defaultCenter={{lat: 10.6840, lng: 122.9563}}
                             center={center}
                             defaultZoom={20}>
                             <div
                               key={"Center Location"}
                               lat={center.lat}
                               lng={center.lng}>
                               <div style={{justifyContent: "center"}}>
                               <Row>
                                 <Glyphicon className="pull-center" glyph="map-marker"
                                   style={{marginRight: 15, color: "red", fontSize: 30}}
                                   onClick={()=>{}}/>
                               </Row>
                               </div>
                             </div>
                       </GoogleMapReact>
                 </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={()=>{this.setState({showMapOverlay: false})}}>Close</Button>
            </Modal.Footer>
           </Modal>);
  }

  getItemWithId(id, type) {
    var itemList = _.find(this.props.dropDowns, (dropDown)=>{
                                  return dropDown.name === type;
                          });
    if(itemList != null) {
      return _.find(itemList.items, (item)=>{
                      return item.id == id;
                    });
    } else {
      return null;
    }

  }

  onChangeEventReoccurring = (e) =>{
    const {checked} = e.target;

    this.props.onChangeNewItemField('isReoccurring',checked);
    this.setState({ eventReoccurring:checked });
  }

  renderEventReoccuring = () =>{
    const {eventReoccurring,eventFrequency} = this.state;
    const {newDropDown} = this.props;

    if(eventReoccurring){
      return (
        <React.Fragment>
          <Row>
            <Col md={4} mdOffset={4}>
              <FormGroup style={{textAlign:'left'}}>
                <div>Select Frequency</div>
                <div>
                  <FormControl
                    value={newDropDown.frequency || ''}
                    componentClass='select'
                    onChange={(e) => {
                      this.setState({eventFrequency:e.target.value});
                      this.props.onChangeNewItemField('frequency', e.target.value);
                    }}
                  >
                    <option value={''}></option>
                    <option value={'daily'}>Daily</option>
                    <option value={'weekly'}>Weekly</option>
                    <option value={'monthly'}>Monthly</option>
                  </FormControl>
                </div>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4} mdOffset={4}>
              <FormGroup style={{textAlign:'left'}}>
                <div>Every</div>
                <div>
                  <FormControl
                    type='number'
                    value={newDropDown.frequencyNumber || ''}
                    onChange={(e) => {
                      this.props.onChangeNewItemField('frequencyNumber', e.target.value)
                    }}
                  />
                </div>
              </FormGroup>
            </Col>
          </Row>
          {this.renderEventFrequency()}
        </React.Fragment>
      )
    }

    return false;
  }

  renderEventFrequency = () =>{
    const {eventFrequency} = this.state;
    const dayDropdown = [];

    for(let x = 1; x < 31; x++){
      dayDropdown.push(<option value={x}>{x}</option>);
    }

    if(eventFrequency === 'weekly'){
      return (
        <Row>
          <Col md={6} mdOffset={3}>
            <FormGroup>
              <ButtonGroup>
                <Button>Su</Button>
                <Button>M</Button>
                <Button>T</Button>
                <Button>W</Button>
                <Button>Th</Button>
                <Button>F</Button>
                <Button>S</Button>
              </ButtonGroup>
            </FormGroup>
          </Col>
        </Row>
      )
    }else if(eventFrequency === 'monthly'){
      return (
        <React.Fragment>
          <Row>
            <Col md={2} mdOffset={4}>
              <FormGroup style={{textAlign:'left'}}>
                <Radio name='type' type={'radio'}>Each:</Radio>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup style={{textAlign:'left'}}>
                <FormControl
                    componentClass='select'
                  >
                  {dayDropdown}
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={2} mdOffset={4}>
              <FormGroup style={{textAlign:'left'}}>
                <Radio name='type' type={'radio'}>On:</Radio>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <FormControl
                  componentClass='select'
                >
                  <option value='First'>First</option>
                  <option value='Second'>Second</option>
                  <option value='Third'>Third</option>
                  <option value='Fourth'>Fourth</option>
                  <option value='Fifth'>Fifth</option>
                  <option value='Last'>Last</option>
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <FormControl
                  componentClass='select'
                >
                  <option value='Sunday'>Sunday</option>
                  <option value='Monday'>Monday</option>
                  <option value='Tuesday'>Tuesday</option>
                  <option value='Wednesday'>Wednesday</option>
                  <option value='Thursday'>Thursday</option>
                  <option value='Friday'>Friday</option>
                  <option value='Saturday'>Saturday</option>
                  <option value='Weekend'>Weekend</option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
        </React.Fragment>
      )
    }

    return null;
  }
}

export default FormDataAddItemPanel;
